export function createMetaInfoMixin () {
  return {
    mounted () {
      this._syncMetaInfo()
    },
    updated () {
      this._syncMetaInfo()
    },
    methods: {
      _syncMetaInfo () {
        const metaInfo = this.$options.metaInfo
        if (!metaInfo) return
        const info = typeof metaInfo === 'function' ? metaInfo.call(this) : metaInfo
        if (info?.title) {
          document.title = info.title
        }
        if (Array.isArray(info?.meta)) {
          for (const tag of info.meta) {
            if (tag.name) {
              let el = document.querySelector(`meta[name="${tag.name}"]`)
              if (!el) {
                el = document.createElement('meta')
                el.setAttribute('name', tag.name)
                document.head.appendChild(el)
              }
              el.setAttribute('content', tag.content || '')
            }
          }
        }
      }
    }
  }
}
